"use strict";require("core-js/modules/es.array.fill");require("core-js/modules/es.array.map");require("core-js/modules/es.array.slice");require("core-js/modules/es.number.constructor");require("core-js/modules/es.number.is-nan");require("core-js/modules/es.parse-int");exports.__esModule = true;exports.default = _default;

var _is = require("../../is");








var getFromArr = function getFromArr(hmsArr) {
  var arr = hmsArr.slice(0);
  if (arr.length !== 3) {
    arr = new Array(3).
    fill(0).
    map(function (val, ind) {return hmsArr[ind] || 0;});
  }var
  h = hmsArr[0],m = hmsArr[1],s = hmsArr[2];
  return { h: h, m: m, s: s };
};

var getVal = function getVal(val) {
  var parsed = parseInt(val);
  return Number.isNaN(parsed) ? 0 : parsed;
};


/**
    * Возвращает количество секунд. Принимает объект или массив часов, минут, секунд
    *
    *
    * @param {HmsType} hms
    * @example
    * hmsToSec( { h: 0, m: 2, s: 3 } ) // 123
    * hmsToSec( { h: '00', m: '02', s: '03' } ) // 123
    * hmsToSec( [ 0, 2, 3 ] ) // 123
    * hmsToSec( [ '00', '02', '03' ] ) // 123
    * @returns {number} seconds
    * @memberof Time
    */
function _default(hms) {
  var seconds = 0;
  var d = (0, _is.isArr)(hms) ? getFromArr(hms) : hms;

  seconds += getVal(d.h) * 3600;
  seconds += getVal(d.m) * 60;
  seconds += getVal(d.s);

  return seconds;
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/convert/hmsToSec.js
// module id = 626
// module chunks = 0